export default "__VITE_ASSET__YZG6FXzp__"